import { render, staticRenderFns } from "./JobApplicationStatusBadge.htm?vue&type=template&id=22a7a4aa&"
import script from "./JobApplicationStatusBadge.ts?vue&type=script&lang=js&"
export * from "./JobApplicationStatusBadge.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports